import { Modal, Button } from "antd";

interface IProps {
  visualizar: boolean;
  setVisualizar: any;
}

export const ModalVisualizarAviso: React.FC<IProps> = (props: IProps) => {


  const onCancel = () => {
    props.setVisualizar(false)
  }

  return (
    <Modal
      className="ant-modal-close-x2"
      maskStyle={{
        backgroundColor: "rgba(6, 100, 144 ,0.71)",
      }}
      visible={props.visualizar}
      onCancel={onCancel}
      width={800}
      footer={[
        <Button key="B_CERRAR_1" className="button-gray-ghost m-0" onClick={onCancel}>
          Cerrar
        </Button>,
      ]}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div style={{ textAlign: 'justify', fontSize: '1.2em' }}>
        <p style={{ fontSize: '1.5em', fontWeight: 'bold' }}>
          ¡Atención!
        </p>
        <br />
        <p>
        Al final de la tabla se calculará el total de experiencia acumulada en años y meses. Por favor, verifique que:
        <br />
        <br />
        1. El total de experiencia pueda ser verificado con los soportes que se adjuntan. Evite repetir registros, ya que estos se sumarán a la experiencia. Si se trata del mismo período, una los PDF y cárguelos como un solo registro.
        <br />
        <br />
        2. El total debe estar sustentado con los soportes ingresados. Puede eliminar y editar los registros.
        </p>
      </div>
    </Modal>
  );
};
